<template>
  <nav class="navbar navbar-expand-lg sticky-top">
    <div class="container-fluid">
      <img src="@/assets/static/img/plyo-logo.svg" alt="..." @click="onClickLogo" />
      <button type="button"
              class="navbar-toggler navbar-toggler-right"
              :class="{toggled: $sidebar.showSidebar}"
              aria-controls="navigation-index"
              aria-expanded="false"
              aria-label="Toggle navigation"
              @click="toggleSidebar">
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
      </button>
      <div class="collapse navbar-collapse justify-content-center" style="width: 100%">
        <div class="navbar-title">
          <div class="name">{{ businessName }}</div>
          <div class="location">{{ businessLocation }}</div>
        </div>
      </div>
      <div class="collapse navbar-collapse justify-content-end" style="width: 130px;">
        <button class="btn-basic" @click="signOut">
          SIGN OUT
        </button>
      </div>
    </div>
  </nav>
</template>
<script>
  export default {
    computed: {
      routeName () {
        const {name} = this.$route
        return this.capitalizeFirstLetter(name)
      },
      businessName () {
        return this.$store.getters.advertiser.name
      },
      businessLocation () {
        return this.$store.getters.advertiser.location
      }
    },
    data () {
      return {
        activeNotifications: false
      }
    },
    methods: {
      capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      toggleNotificationDropDown () {
        this.activeNotifications = !this.activeNotifications
      },
      closeDropDown () {
        this.activeNotifications = false
      },
      toggleSidebar () {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      hideSidebar () {
        this.$sidebar.displaySidebar(false)
      },
      signOut() {
        this.$store.dispatch('clearState');
        this.$router.push('/login');
      },
      onClickLogo() {
        this.$router.push('/')
      },
    }
  }
</script>
<style>

</style>
